var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccent2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 56,
    viewBox: "0 0 51 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1806 51.7952C38.9806 50.4482 44.006 49.7687 48.881 49.1462C49.931 49.0157 50.9058 49.744 50.9808 50.77C51.1308 51.7967 50.3804 52.7357 49.4054 52.8662C44.6804 53.4655 39.8059 54.1067 35.2309 55.4035C34.2558 55.6847 33.2054 55.1057 32.9054 54.1097C32.6054 53.1145 33.2056 52.0772 34.1806 51.7952Z",
    fill: "#E1E9FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6312 32.698C27.3562 24.8147 36.0562 17.9462 43.6312 9.85147C44.3062 9.09547 45.5062 9.05497 46.2562 9.76072C47.0062 10.4672 47.0809 11.6552 46.3309 12.4112C38.7559 20.5292 30.0559 27.4202 22.3309 35.3267C21.5809 36.0647 20.3812 36.0752 19.6312 35.3492C18.9562 34.624 18.8812 33.436 19.6312 32.698Z",
    fill: "#E1E9FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.15443 2.37623C4.92944 6.88823 4.70487 11.4002 4.47987 15.913C4.47987 16.9465 3.57943 17.7445 2.52943 17.6942C1.47943 17.6432 0.729874 16.7635 0.729874 15.7292C0.954872 11.2097 1.17944 6.69098 1.40443 2.17223C1.47943 1.13873 2.37958 0.345982 3.42958 0.402232C4.40458 0.458482 5.22943 1.34348 5.15443 2.37623Z",
    fill: "#E1E9FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccent2);
export default __webpack_public_path__ + "static/media/accent2.d3c6020c953386502dc0ee26e8977110.svg";
export { ForwardRef as ReactComponent };